<template>
  <div class="group group--sidebar group--df-column">
    <div class="group group--df group--wide">
      <div>
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 group__title mb0"
          v-html="pageTitle" />
        <p v-if="selectedAppointmentType === `video` && !queryData" class="p group__description">Come back and log in five minutes before your scheduled start time, then click the video chat link to begin.</p>
        <p v-if="selectedAppointmentType === `phone` && !queryData" class="p group__description">Your counselor will call you directly at {{ userPhone }}.</p>

        <p v-if="f2fSelected" class="p group__description">We’ve forwarded your details on to our team, and we’ll contact you shortly.</p>

        <module-button
          v-if="!isNewUser"
          button="primary"
          :link="buttonContent.link"
          :label="buttonContent.label"
        />

        <module-button
          v-if="isNewUser"
          button="primary"
          label="Go to login"
          type="button"
          @click.native="resetAndRedirect"
        />
      </div>

      <div class="illustration illustration--success" />
    </div>

    <div class="spacer" />

    <div v-if="!f2fSelected && !queryData">
      <h2 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h2">How should I get ready?</h2>
      <p class="p mw640 mt0">Find a quiet, comfortable spot where you can speak privately. Make sure there’s a strong internet signal and enough light so the counselor can see your face.</p>

      <h2 
        v-if="selectedAppointmentType === `video`" 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h2">Can I video chat with a tablet or cell phone?</h2>
      <p v-if="selectedAppointmentType === `video`" class="p mw640 mt0">Sure. You can use whatever device you prefer.</p>

      <h2 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h2">What should I expect?</h2>
      <p class="p mw640 mt0">A conversation. It’ll just be you and your counselor, so the two of you will be able to talk openly about what’s going on to figure out helpful next steps.</p>

      <h2 
        v-if="selectedAppointmentType === `video`" 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h2">What if I miss the video chat start time?</h2>
      <p v-if="selectedAppointmentType === `video`" class="p mw640 mt0">If you’re just a few minutes late, you can still log in and join. If you miss your session entirely, please call <a :href="`tel:${org.phone}`" class="tdn">{{ org.phone }}</a> and we’ll find another time for you and your counselor to talk.</p>

      <h2 
        v-if="selectedAppointmentType === `phone`" 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h2">What if I miss my call?</h2>
      <p v-if="selectedAppointmentType === `phone`" class="p mw640 mt0">Please call <a :href="`tel:${org.phone}`" class="tdn">{{ org.phone }}</a> and we’ll find another time for you and your counselor to talk.</p>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import phone from 'utils/phone';

// 3rd party
import moment from 'moment';

// Export
export default {
  name: 'view-register',


  // Computed
  computed: {
    ...mapGetters('provider', ['provider', 'selectedSlot', 'selectedAppointmentType']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('app', ['org']),
    ...mapGetters('questions', ['f2fSelected']),
    ...mapGetters('appointment', ['queryData']),
    pageTitle() {

      if( this.queryData ) {
        return 'Your request has been submitted and you should get a response within 48 hours';
      }

      if ( this.provider && this.selectedSlot && this.selectedAppointmentType && !this.queryData ) {
        const providerName = this.provider.fullname || this.provider.full_name;
        const appointmentType = `${this.selectedAppointmentType} ${this.selectedAppointmentType === 'video' ? 'chat' : 'call'}`;
        const date = moment(this.selectedSlot.timeslot).format('dddd, MMMM D [at] h:mma');

        return `You’re all set.<br> Your ${appointmentType} with ${providerName} is on ${date}.`;
      }

      if ( this.f2fSelected ) {
        return 'Thank you for requesting an in-person meeting with a counselor. We will be in touch shortly with a list of suggested counselors.';
      }

      return 'You’re all set.<br> Your [video chat] with [someone] is on a [certain time].';
    },

    userPhone() {
      if ( localStorage.getItem('updateUser') ) {
        const getPhone = JSON.parse(localStorage.getItem('updateUser')).phone;
        return phone(getPhone);
      }
    },

    isNewUser() {
      return localStorage.getItem('newUser');
    },

    buttonContent() {
      return {
        link: this.isNewUser ? 'login' : 'home',
        label: this.isNewUser ? 'Go to login' : 'Return to homepage',
      };
    },
  },

  // Methods
  methods: {
    ...mapActions('provider', ['selectAppointmentType']),

    resetAndRedirect() {
      this.$store.dispatch('auth/resetAllData');

      this.$nextTick(() => {
        this.$router.push({ path: '/log-in' });
      });
    },
  },


  // Lifecycles
  beforeDestroy() {
    // TODO: Check if this was necessary
    // window.history.forward(1);
  },

  beforeRouteEnter(to, from, next) {
    if ( !from || !from.name ) {
      next({ name: 'home' });
    }

    if( from.name === 'register-verification') {
      localStorage.removeItem('newUser');
    }
    next();
  },

  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('newUser');
    this.selectAppointmentType(null);
    this.$store.commit('appointment/SAVE_QUERY_DATA', null);
    next();
  },
};
</script>



// WEBPACK FOOTER //
// RegisterSuccess.vue?0aef530c